export default "__VITE_ASSET__ca102bc2__"